import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

// import _ from 'lodash';
import { api } from '@/api';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'GET_TRANSACTIONS_INFO';
interface Params {
  accountId: string;
}


interface Result {
  totalContributions: number;
  pendingTransfer: number;
}
const useGetTransactionsInfoQuery = ({ accountId }: Params) => {
  const { data, isLoading } = useQuery([QUERY_KEY, accountId], () =>
    api.get(API_URL.ACCOUNTS_CLOSURE_AMOUNTS, {
      params: {
        account_id: accountId,
      },
    })
  );
  const result = useMemo<Result>(() => {
    const currentData = data?.data;
    return {
      totalContributions: currentData?.total_contributions_amount || 0,
      pendingTransfer: currentData?.toa_amount || 0,
    };
  }, [data?.data]);

  const isPendingPresent = useMemo(() => !!result.pendingTransfer, [result.pendingTransfer]);

  const isTotalPresent = useMemo(() => !!result?.totalContributions, [result?.totalContributions]);
  return {
    isTotalPresent,
    isPendingPresent,
    data: result,
    isLoading,
  };
};

export default useGetTransactionsInfoQuery;
